export default __webpack_public_path__ + "static/media/telegroup.6bb7aa9b.png";